<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a class="action" @click="openChat">
        <i class="iconfont icon-kefu" />
        <span class="action-label">{{ $t('user.service.support') }}</span>
      </a>
      <span class="action-seam" />
      <a class="action" @click="openHelp">
        <i class="iconfont icon-wendang" />
        <span class="action-label">{{ $t('user.service.doc') }}</span>
      </a>
      <span class="action-seam" />
      <a-dropdown>
        <div class="action">
          <i class="iconfont icon-lvzhou_yuyanqiehuan" />
          <span class="action-label">{{ langName() }}</span>
          <a-icon type="down" class="action-caret" />
        </div>
        <a-menu slot="overlay" :selected-keys="currentLangKeys" @click="onLangClick">
          <a-menu-item key="ja-JP">
            <a>日本語</a>
          </a-menu-item>
          <a-menu-item key="en-US">
            <a>English</a>
          </a-menu-item>
          <a-menu-item key="zh-CN">
            <a>简体中文</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>

      <span class="action-seam" />
      <a-dropdown>
        <div class="action action-user">
          <span v-if="initial()" class="action-initial">{{ initial() }}</span>
          <span class="action-label">{{ nickname() }}</span>
          <a-icon type="down" class="action-caret" />
        </div>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="1">
            <a href="javascript:;" @click="showUInfo">
              <a-icon type="key" />
              <span>{{ $t('user.accountSetting') }}</span>
            </a>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="12">
            <a href="javascript:;" @click="showNameChange">
              <a-icon type="user" />
              <span>{{ $t('user.name.change.title') }}</span>
            </a>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout" />
              <span>{{ $t('user.signout') }}</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import { changeUserLanguage } from '@/api/data'
import { getI18nLanguage } from '@/locales'
import CNSupport from '@/components/GlobalHeader/CNSupport.vue'

export default {
  name: 'UserMenu',
  data () {
    return {
      role: 0
    }
  },
  components: {
    NoticeIcon
  },
  created () {
    var role = Vue.ls.get('role')
    this.role = role
    var locInfo = window.localStorage.getItem('local')
    if (locInfo) {
      var locObj = JSON.parse(locInfo)
      this.cLocal = locObj.name
    }
  },
  computed: {
    // 高亮当前真正在用的语言，不然开了下拉看不出自己选了哪个
    currentLangKeys () {
      return [this.currentLang()]
    }
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'lang']),
    // 服务端只存用户偏好，调试模式下会和页面实际渲染的语言对不上，
    // 这里一律取 i18n 当下生效的 locale，保证右上角显示的就是屏幕上看到的那套文案
    currentLang () {
      return getI18nLanguage() || this.lang() || ''
    },
    langName () {
      const lang = this.currentLang()
      if (lang.indexOf('ja') === 0) return '日本語'
      if (lang.indexOf('zh') === 0) return '简体中文'
      return 'English'
    },
    // 昵称取首字做徽标：这排按钮里只有它能说明「当前是谁在操作」
    initial () {
      const name = (this.nickname() || '').trim()
      return name ? name.charAt(0).toUpperCase() : ''
    },
    handleLogout () {
      const that = this

      this.$confirm({
        title: this.$t('user.tip'),
        content: this.$t('user.signOutTip'),
        okText: this.$t('user.action.ok'),
        cancelText: this.$t('user.action.cancel'),
        onOk () {
          return that.Logout({}).then(() => {
            // clear db
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: 'Error',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    },
    onLangClick (e) {
      window.localStorage.setItem('mLang', e.key)
      const reload = () => window.location.reload()
      // 同步到用户资料是锦上添花：接口失败也得重载，否则这个按钮看着就像坏了
      changeUserLanguage({
        lang: e.key
      }).then(reload).catch(reload)
    },
    showUInfo () {
      this.$emit('showAccountModal')
    },
    showNameChange () {
      this.$emit('showNameModal')
    },
    openChat () {
      // let mLang = window.localStorage.getItem('mLang')
      // if (!mLang) {
      //   mLang = window.navigator.languages
      // }
      if (window.location.hostname === 'cloud.reflexwireless.jp') {
        window.open('http://chat.reflexwireless.jp/chat/1i6jl3i7m', '_blank')
      } else if (window.location.hostname === 'cloud.breathmeters.cn') {
        this.showModal(CNSupport, '客服支持', 300, 440)
      } else {
        window.open('http://chat.reflexwireless.jp/chat/1iaqcdmak', '_blank')
      }
    },
    openHelp () {
      if (this.currentLang().indexOf('ja') === 0) {
        window.open('https://www.reflexwireless.jp/cloud-manager/', '_blank')
      } else {
        window.open('https://www.reflexwireless.com/en/cloud-manager/', '_blank')
      }
    }
  }
}
</script>
<style lang='less' scoped>
/* 这一排是机箱上的控制簇：
   图标退到 --chrome-text-dim，文字是 --chrome-text，悬停时统一提亮到 --chrome-text-on，
   图标转成品牌蓝 —— 和侧栏菜单、头部触发器的反馈语言保持一致。
   以前这里的 color/尺寸全靠行内 style 顶着，还带一个拼错的 hight，改起来无从下手 */

.content-box {
  display: flex;
  align-items: center;
  height: 100%;
}

.action {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 10px;
  border-radius: 3px;
  color: var(--chrome-text);
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease;

  &:hover {
    color: var(--chrome-text-on);
    background: rgba(255, 255, 255, 0.06);
  }

  .iconfont {
    color: var(--chrome-text-dim);
    font-size: 14px;
    transition: color 0.18s ease;
  }

  &:hover .iconfont {
    color: var(--brand-2);
  }
}

.action-label {
  margin-left: 6px;
}

.action-caret {
  margin-left: 4px;
  color: var(--chrome-text-dim);
  font-size: 10px;
  transition: color 0.18s ease;
}

.action:hover .action-caret {
  color: var(--chrome-text-on);
}

/* 三段短接缝替掉 a-divider：antd 的垂直分割线是 border-left + 浅灰边框色，
   压在深色机箱上会亮成一根白线；这里用机箱自己的接缝色，长度也只有 14px */
.action-seam {
  flex: 0 0 1px;
  width: 1px;
  height: 14px;
  margin: 0 6px;
  background: var(--seam-strong);
}

.action-user {
  padding-left: 6px;

  .action-label {
    display: inline-block;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.action-initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-right: 7px;
  border: 1px solid rgba(56, 182, 240, 0.32);
  border-radius: 50%;
  background: rgba(56, 182, 240, 0.14);
  color: var(--brand-2);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
</style>
